export function remove() {
    window.history.replaceState(null, null, window.location.pathname + window.location.hash);
}
